import "../css/app.css";
import "./bootstrap";

import { createInertiaApp } from "@inertiajs/react";
import * as Sentry from "@sentry/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createRoot, hydrateRoot } from "react-dom/client";
import { Providers } from "./providers";

const appName = import.meta.env.VITE_APP_NAME || "Laravel";

if (!import.meta.env.DEV) {
	Sentry.init({
		dsn: "https://74e93b0e1d275e95dceb2f53e72ad10e@o1324262.ingest.us.sentry.io/4508631200432128",
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
		],
		tracesSampleRate: 1.0,
		tracePropagationTargets: ["localhost", "https://stage.rtl.dzarsky.eu"],
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		environment: import.meta.env.VITE_APP_ENVIRONMENT,
	});
}

createInertiaApp({
	title: (title) => `${title} - ${appName}`,
	resolve: (name) =>
		resolvePageComponent(
			`./Pages/${name}.tsx`,
			import.meta.glob("./Pages/**/*.tsx"),
		),
	setup({ el, App, props }) {
		if (import.meta.env.DEV) {
			createRoot(el).render(
				<Providers>
					<App {...props} />
				</Providers>,
			);
			return;
		}

		hydrateRoot(
			el,
			<Providers>
				<App {...props} />
			</Providers>,
		);
	},
	progress: {
		color: "#006FEE",
	},
});
